const PRODUCT_API_TYPE = {
  MERCHANT_API: 'merchant_api',
  CONTENT_API: 'content_api', // should consider undefined or null to be content_api
};

const PRODUCT_API_AUTH_TYPE = {
  OAUTH_TOKEN: 'oauth_token',
  SERVICE_ACCOUNT: 'service_account',
};

export { PRODUCT_API_TYPE, PRODUCT_API_AUTH_TYPE };
